<template>
  <FormControl :indent="indent" :label="false">
    <div class="row py-0">
        <div class="form-check">
          <input class="form-check-input" :name="name" v-model="model[name]" type="checkbox" :value="value ? value : 1" :id="id ? id : name">
          <label class="form-check-label" :for="id ? id : name"><span></span>{{ label }}</label>
        </div>
    </div>
  </FormControl>

</template>

<script>
  import FormControl from './FormControl';

  export default {
    name: 'checkbox',
    props: ['label', 'multi', 'model', 'value', 'name', 'id', 'options', 'indent'],
    components: {
      FormControl
    },
    methods: {
      onChange($ev) {
      },
      getChecked() {
        return this.model.find(this.value) ? true : false
      }
    }
  }
</script>
